import GridWrapper from "@components/elements/GridWrapper";
import LoginForm from "@components/login/form";
import { useAuth } from "@hooks/auth/useAuth";
import {
  Box,
  Divider,
  FormHelperText,
  Link,
  Typography,
} from "@material-ui/core";
import React from "react";
import GoogleButton from "react-google-button";

interface Props {
  returnTo?: string;
}

export default function Login(props: Props): JSX.Element {
  const { returnTo } = props;
  const { authLogin, googleAuth } = useAuth();
  const [error, setError] = React.useState();

  const onLogin = ({ email, password }) => {
    authLogin({ email, password }, returnTo)
      .then((result) => {
        console.log({ result });
      })
      .catch((error) => {
        console.log({ error });
        setError(error.description);
      });
  };

  const onGoogle = () => {
    googleAuth({ mode: "login", returnTo }).catch((error) => {
      console.log({ error });
      setError(error.description);
    });
  };

  return (
    <GridWrapper spacing={2}>
      <LoginForm onSubmit={onLogin} />

      {!!error && <FormHelperText error>{error}</FormHelperText>}

      <Box display="flex" alignItems="center">
        <Box flex={1}>
          <Divider />
        </Box>
        <Typography style={{ paddingLeft: 8, paddingRight: 8 }}>OR</Typography>
        <Box flex={1}>
          <Divider />
        </Box>
      </Box>

      <Box display="flex">
        <GoogleButton
          style={{ flex: 1 }}
          type="dark"
          label="Sign in with Gooogle"
          onClick={onGoogle}
        />
      </Box>

      <Box mt={4}>
        <Typography variant="subtitle1">
          New to Best Golf Fitness?{" "}
          <Link color="secondary" href="/signup/account">
            Sign up now
          </Link>
          .
        </Typography>
        <Typography variant="caption" color="textSecondary">
          This page is protected by Google reCAPTCHA to ensure you're not a bot.
        </Typography>
      </Box>
    </GridWrapper>
  );
}
